import React, { useRef } from 'react';
import { useInView } from '../hooks';

const REVIEWS = [
  { initials: 'SJ', name: 'Sarah J.', role: 'Airbnb Host · Waterloo', text: '"Fantastic service! Our Airbnb was spotless. Guests commented on how clean the flat was. Will definitely book again."' },
  { initials: 'DM', name: 'David M.', role: 'Tenant · London Bridge', text: '"Great end of tenancy cleaning, highly recommend! Got my full deposit back with no issues. Thorough and professional."' },
  { initials: 'RP', name: 'Rachel P.', role: 'Homeowner · Southwark', text: '"I use them for weekly cleans and they\'re always on time, thorough and lovely. Couldn\'t be happier with the results."' },
];

function ReviewCard({ initials, name, role, text, delay, inView }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 18, padding: '30px 26px',
      border: '1.5px solid var(--border)',
      transition: 'transform 0.2s, box-shadow 0.2s, opacity 0.6s',
      opacity: inView ? 1 : 0,
      transform: inView ? 'translateY(0)' : 'translateY(24px)',
      transitionDelay: `${delay}ms`,
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 14px 40px rgba(0,0,0,0.07)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
      <div style={{ color: '#f59e0b', fontSize: 16, marginBottom: 12 }}>★★★★★</div>
      <p style={{ color: 'var(--text)', fontSize: '0.92rem', lineHeight: 1.65, marginBottom: 20, fontStyle: 'italic' }}>{text}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 42, height: 42,
          background: 'linear-gradient(135deg, var(--blue), var(--sky))',
          borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontWeight: 700, fontSize: '0.85rem',
        }}>{initials}</div>
        <div>
          <div style={{ fontWeight: 600, fontSize: '0.88rem', color: 'var(--navy)' }}>{name}</div>
          <div style={{ fontSize: '0.76rem', color: 'var(--muted)' }}>{role}</div>
        </div>
      </div>
    </div>
  );
}

export default function Reviews() {
  const ref = useRef(null);
  const inView = useInView(ref, 0.1);

  return (
    <section id="reviews" style={{ padding: '100px 5%', background: 'var(--cream)', textAlign: 'center' }}>
      <div ref={ref} style={{ maxWidth: 560, margin: '0 auto 48px' }}>
        <div style={{ fontSize: '0.78rem', fontWeight: 600, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: 12 }}>Customer Reviews</div>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.7rem, 3.5vw, 2.4rem)', color: 'var(--navy)', lineHeight: 1.25, marginBottom: 14 }}>
          What Our Clients Say
        </h2>
        <p style={{ color: 'var(--muted)', fontSize: '0.97rem', lineHeight: 1.7 }}>
          Trusted by homeowners, landlords, and Airbnb hosts across SE1 London.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24, maxWidth: 960, margin: '0 auto' }}>
        {REVIEWS.map((r, i) => <ReviewCard key={r.name} {...r} delay={i * 120} inView={inView} />)}
      </div>
    </section>
  );
}
